import { LayoutGenerator } from "./utils/layoutGenerator"
import { Button } from "materials/button/menus/model"
import { Input } from "materials/input/menus/model"
/**
 * 门户文本默认配置数据
 */
export const home = [
  {
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["ListPageSearchComponentPlugin"],
    appId: "",
    background: [
      {
        color: "rgba(0, 0, 0, 0.24)",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    titleOptions: [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Input({
                  top: 0,
                  left: 0,
                  width: 200,
                  height: 50,
                  elementInLayoutId: 2,
                  textPaddingTypeFlag: 2,
                  fontSize: 12,
                  paddingLeft: 0,
                  paddingRight: 0,
                  placeHolderFontSize: 12,
                  showDelIcon: true,
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  borderColor: "rgba(0, 0, 0, 0.1)",
                  borderWidth: [0, 0, 0, 1],
                  bgColor: "rgba(255,255,255,0.9)",
                  searchType: "searchInput"
                }),
                new Button({
                  top: 0,
                  left: 200,
                  width: 100,
                  height: 50,
                  elementInLayoutId: 3,
                  content: "搜索",
                  searchType: "searchButton",
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  bgColor: "rgba(29, 107, 233, 1)",
                  hoverBackground: "rgba(6, 80, 200, 1)",
                  bgColorIsThemeColor: true,
                  fontSize: 12,
                  borderWidth: 0,
                  background: [
                    {
                      isThemeColor: true,
                      label: "颜色",
                      type: "color",
                      color: "rgba(29, 107, 233, 1)"
                    }
                  ]
                })
              ]
            }
          ]
        }
      ]
    }).rows
  }
]
/**
 * 大屏文本默认配置数据
 */
export const bs = []

/**
 * app搜索默认配置数据
 */
export const appHome = [
  {
    styleName: "自由布局",
    thumbnail: require("../../assets/images/leftMenu/layout/layout_1.png"),
    pluginName: ["ListPageSearchComponentPlugin"],
    appId: "",
    background: [
      {
        color: "rgba(0, 0, 0, 0.24)",
        isThemeColor: false,
        label: "颜色",
        type: "color"
      }
    ],
    titleOptions: [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              disableSetData: true,
              elementOptions: [
                new Input({
                  top: 68,
                  left: 144,
                  width: 400,
                  height: 46,
                  elementInLayoutId: 2,
                  borderWidth: 1,
                  borderColor: "#999",
                  searchType: "searchInput"
                }),
                new Button({
                  top: 68,
                  left: 444,
                  width: 100,
                  height: 46,
                  elementInLayoutId: 3,
                  content: "搜索",
                  searchType: "searchButton",
                  borderTopRightRadius: 5,
                  borderBottomRightRadius: 5
                })
              ]
            }
          ]
        }
      ]
    }).rows
  }
]
